<template>
  <div class="lessons__filters">
    <Tabs
      :tabs="tabsList"
      :selected="activeFilter"
      @select="setFilter"
    />
  </div>
</template>

<script>
import Tabs from '../common/Tabs.vue'

export default {
  components: { Tabs },
  props: {
    activeFilter: {
      type: String,
      default: 'draft'
    },
    userDaysSorted: {
      type: Array,
      default: () => []
    },
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userDaysDrafts () {
      return this.userDaysSorted.filter(userDay => userDay.state === 'draft')
    },
    userDaysApproved () {
      return this.userDaysSorted.filter(userDay => userDay.state === 'approved')
    },
    userDaysSent () {
      return this.userDaysSorted.filter(userDay => userDay.state === 'sent')
    },
    tabsList () {
      const sentLabel = this.isSalaryIntegrationActive
        ? 'Sendt til lønsystem'
        : 'Er indberettet'

      return [
        { id: 'draft', title: `Efterbehandling (${this.userDaysDrafts.length})` },
        { id: 'approved', title: `Godkendt (${this.userDaysApproved.length})` },
        { id: 'sent', title: `${sentLabel} (${this.userDaysSent.length})` }
      ]
    }
  },
  methods: {
    setFilter (filter) {
      this.$emit('change', filter)
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';
.lessons__filters {
  display: flex;
}

.lessons__filters__filter {
  padding: 0.5rem 2rem;
  border: 1px solid var(--border-color);
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.25s;
  user-select: none;
}

.lessons__filters__filter:active {
  transform: scale(0.98);
}

.lessons__filters__filter.lessons__filters__filter--active {
  color: var(--blue);
}

.lessons__filters .lessons__filters__filter:first-child {
  border-radius: 4px 0 0 4px;
}

.lessons__filters .lessons__filters__filter:last-child {
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// SalaryFilters.vue?54fe091f